import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from '../styles';
import InfoTitle from '../../InfoTitle';

export default function KitTeam({ kits, selectedMatch, position, type }) {
  const { t } = useTranslation();
  const imageLocal =
    selectedMatch && type === 'local'
      ? selectedMatch.homeTeam.shieldImageUrl
      : '';
  const imageAway =
    selectedMatch && type === 'away'
      ? selectedMatch.awayTeam.shieldImageUrl
      : '';

  return (
    <>
      <S.TeamColumn type={type}>
        <S.ShieldBackground image={imageLocal || imageAway} type={type} />
        <S.KitDisplayColumn type={type}>
          {type === 'local' && (
            <>
              {kits.homeTeamPlayer && position === 'player' && (
                <>
                  <S.KitColumn>
                    <S.ShirtTile image={kits.homeTeamPlayer.tshirtImage} />
                    <S.PantsTile image={kits.homeTeamPlayer.shortsImage} />
                    <S.SocksTile image={kits.homeTeamPlayer.socksImage} />
                  </S.KitColumn>
                  <S.KitColumn isInfo>
                    <InfoTitle
                      title={t('shirt')}
                      textColor="dark"
                      borderColor="coral"
                    >
                      {kits.homeTeamPlayer.tshirtNumber
                        ? `${kits.homeTeamPlayer.tshirtNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('shorts')}
                      textColor="dark"
                      borderColor="coral"
                    >
                      {kits.homeTeamPlayer.shortsNumber
                        ? `${kits.homeTeamPlayer.shortsNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('socks')}
                      textColor="dark"
                      borderColor="coral"
                    >
                      {kits.homeTeamPlayer.socksNumber
                        ? `${kits.homeTeamPlayer.socksNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                  </S.KitColumn>
                </>
              )}
              {kits.homeTeamGoalkeeper && position === 'goalkeeper' && (
                <>
                  <S.KitColumn>
                    <S.ShirtTile image={kits.homeTeamGoalkeeper.tshirtImage} />
                    <S.PantsTile image={kits.homeTeamGoalkeeper.shortsImage} />
                    <S.SocksTile image={kits.homeTeamGoalkeeper.socksImage} />
                  </S.KitColumn>
                  <S.KitColumn isInfo>
                    <InfoTitle
                      title={t('shirt')}
                      textColor="dark"
                      borderColor="coral"
                    >
                      {kits.homeTeamGoalkeeper.tshirtNumber
                        ? `${kits.homeTeamGoalkeeper.tshirtNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('shorts')}
                      textColor="dark"
                      borderColor="coral"
                    >
                      {kits.homeTeamGoalkeeper.shortsNumber
                        ? `${kits.homeTeamGoalkeeper.shortsNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('socks')}
                      textColor="dark"
                      borderColor="coral"
                    >
                      {kits.homeTeamGoalkeeper.socksNumber
                        ? `${kits.homeTeamGoalkeeper.socksNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                  </S.KitColumn>
                </>
              )}
            </>
          )}
          {type === 'away' && (
            <>
              {kits.visitorTeamPlayer && position === 'player' && (
                <>
                  <S.KitColumn>
                    <S.ShirtTile image={kits.visitorTeamPlayer.tshirtImage} />
                    <S.PantsTile image={kits.visitorTeamPlayer.shortsImage} />
                    <S.SocksTile image={kits.visitorTeamPlayer.socksImage} />
                  </S.KitColumn>
                  <S.KitColumn isInfo>
                    <InfoTitle
                      title={t('shirt')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.visitorTeamPlayer.tshirtNumber
                        ? `${kits.visitorTeamPlayer.tshirtNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('shorts')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.visitorTeamPlayer.shortsNumber
                        ? `${kits.visitorTeamPlayer.shortsNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('socks')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.visitorTeamPlayer.socksNumber
                        ? `${kits.visitorTeamPlayer.socksNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                  </S.KitColumn>
                </>
              )}
              {kits.visitorTeamGoalkeeper && position === 'goalkeeper' && (
                <>
                  <S.KitColumn>
                    <S.ShirtTile
                      image={kits.visitorTeamGoalkeeper.tshirtImage}
                    />
                    <S.PantsTile
                      image={kits.visitorTeamGoalkeeper.shortsImage}
                    />
                    <S.SocksTile
                      image={kits.visitorTeamGoalkeeper.socksImage}
                    />
                  </S.KitColumn>
                  <S.KitColumn isInfo>
                    <InfoTitle
                      title={t('shirt')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.visitorTeamGoalkeeper.tshirtNumber
                        ? `${kits.visitorTeamGoalkeeper.tshirtNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('shorts')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.visitorTeamGoalkeeper.shortsNumber
                        ? `${kits.visitorTeamGoalkeeper.shortsNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('socks')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.visitorTeamGoalkeeper.socksNumber
                        ? `${kits.visitorTeamGoalkeeper.socksNumber}${t(
                            'countAcronim'
                          )} ${t('equipment')}`
                        : '-'}
                    </InfoTitle>
                  </S.KitColumn>
                </>
              )}
            </>
          )}
          {type === 'referee' && (
            <>
              {kits.referee && (
                <>
                  <S.KitColumn>
                    <S.ShirtTile image={kits.referee.tshirtImage} />
                    <S.PantsTile image={kits.referee.shortsImage} />
                    <S.SocksTile image={kits.referee.socksImage} />
                  </S.KitColumn>
                  <S.KitColumn isInfo>
                    <InfoTitle
                      title={t('shirt')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.referee.tshirtNumber
                        ? `${kits.referee.tshirtNumber}${t('countAcronim')} ${t(
                            'equipment'
                          )}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('shorts')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.referee.shortsNumber
                        ? `${kits.referee.shortsNumber}${t('countAcronim')} ${t(
                            'equipment'
                          )}`
                        : '-'}
                    </InfoTitle>
                    <InfoTitle
                      title={t('socks')}
                      textColor="white"
                      borderColor="coral"
                    >
                      {kits.referee.socksNumber
                        ? `${kits.referee.socksNumber}${t('countAcronim')} ${t(
                            'equipment'
                          )}`
                        : '-'}
                    </InfoTitle>
                  </S.KitColumn>
                </>
              )}
            </>
          )}
        </S.KitDisplayColumn>
      </S.TeamColumn>
    </>
  );
}

KitTeam.propTypes = {
  selectedMatch: PropTypes.object,
  kits: PropTypes.object,
  position: PropTypes.string,
  type: PropTypes.string,
};

KitTeam.defaultProps = {
  selectedMatch: {},
  kits: {},
  position: '',
  type: '',
};
